package com.shadowings.gero.presentation.component

import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import compose.icons.FeatherIcons
import compose.icons.feathericons.ChevronLeft
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.back_btn_desc
import org.jetbrains.compose.resources.stringResource

@Composable
fun BackIconButton(
    onBackClick: () -> Unit,
    testTagId: String = "back_icon_btn"
) {
    IconButton(
        onClick = onBackClick,
        modifier = Modifier.semantics { testTag = testTagId }
    ) {
        Icon(
            imageVector = FeatherIcons.ChevronLeft,
            contentDescription = stringResource(Res.string.back_btn_desc),
            tint = MaterialTheme.colorScheme.onSurface
        )
    }
}
